var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreparing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1821_8850)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.04163,
    r: 5,
    fill: "#ED7117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57532 4.80585L3.37915 6.07381L3.37915 3.53789L5.57532 4.80585Z",
    fill: "#ED7117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11332 3.28163H6.49332V5.14163H6.18332V2.42913H5.56332V5.14163H5.25332V2.04163H4.63332V5.14163H4.32332V2.50663H3.70332V5.91663H3.62582L3.00892 4.36663L2.28662 4.65183L3.20422 6.95823C3.51422 7.73323 4.26442 8.24163 5.09832 8.24163C6.21122 8.24163 7.11332 7.33953 7.11332 6.22663V3.28163Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1821_8850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.041626)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparing);
export default __webpack_public_path__ + "static/media/preparing.94bfe896a52ae3eb9bccc0d0a076b89a.svg";
export { ForwardRef as ReactComponent };